import { render, staticRenderFns } from "./HealthAndFitness.vue?vue&type=template&id=2a6bd4cc&"
import script from "./HealthAndFitness.vue?vue&type=script&lang=js&"
export * from "./HealthAndFitness.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports